import axios from "../utils/axios";

export const getNotifications = (userName) => {
    return axios.get(`/NotificationHistory/GetUnreadNotificationsOfUser?username=${userName}`);
};

export const getActiveCounts = () => {
    return axios.get(`/UnplannedMaintenance/GetActiveCounts`);
};

export const getAutonomousActiveCounts = () => {
    return axios.get(`/AutonomousMaintenance/GetActiveCounts`);
};

export const getBarCodeContext = (payload) => {
    return axios.get(`/Equipment/GetByBarcodeContext?barcodeContext=${payload}`);
};
